import { render, staticRenderFns } from "./MultiCard.vue?vue&type=template&id=5151335c&"
import script from "./MultiCard.vue?vue&type=script&lang=js&"
export * from "./MultiCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports